/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Automation_Run_Status_LabelInputs */

const en_automation_run_status_label = /** @type {(inputs: Automation_Run_Status_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.status === "succeeded") return /** @type {LocalizedString} */ (`Succeeded`);
	if (i?.status === "skipped") return /** @type {LocalizedString} */ (`Nothing to do`);
	if (i?.status === "failed") return /** @type {LocalizedString} */ (`Failed`);
	return /** @type {LocalizedString} */ (`${i?.status}`)
	
};

const pt_br2_automation_run_status_label = /** @type {(inputs: Automation_Run_Status_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.status === "succeeded") return /** @type {LocalizedString} */ (`Concluída`);
	if (i?.status === "skipped") return /** @type {LocalizedString} */ (`Nada a fazer`);
	if (i?.status === "failed") return /** @type {LocalizedString} */ (`Falhou`);
	return /** @type {LocalizedString} */ (`${i?.status}`)
	
};

/**
* | status | output |
* | --- | --- |
* | "succeeded" | "Succeeded" |
* | "skipped" | "Nothing to do" |
* | "failed" | "Failed" |
* | * | "{status}" |
*
* @param {Automation_Run_Status_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_run_status_label = /** @type {((inputs: Automation_Run_Status_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Run_Status_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_run_status_label(inputs)
	return pt_br2_automation_run_status_label(inputs)
});